const sageThemeConfig = {
  cookieBotId: "b66ede31-4817-4c2b-a4dd-e671cc93f4e0",
  login: "Log in",
  showLogo: true,
  logoURL: "/images/themes/sage/logo.svg",
  hasBackgrounds: false,
  communityName: "Customer panel",
  communityIcon: "/themes/sage/avatars/avatar-moderator.jpg",
  contactEmail: "support@whycatcher.com",
  terms: "/pages/terms-conditions",
  privacy: "/pages/privacy-policy",
  showUserSettingsPayment: true,
  enableDashboardStats: true,
  participantMenu: [
    {
      title: "Settings",
      url: "theme-participant-user-settings",
      icon: "fa-cog",
    },
  ],
  sideMenu: {
    dashboardEnabled: true,
    dashboardName: "Task Dashboard",
    aboutEnabled: true,
    FAQEnabled: true,
    newsEnabled: false,
    contactEnabled: true
  },
  images: {
    aboutImage: [
      {
        url: "/themes/app/pages/hero/about.jpg",
      },
    ],
  },
  tinyMce: {
    content_style:
      "body { color: #7c7c7c; font-size: 14px; font-family: Arial; }",
  },
  dailyCall: {
    style: {
      accent: "#000000", // Main theme color. Used for primary actions and keyboard focus.
      accentText: '#ffffff', // Text color rendered on accent.
      background: '#fbfbfb', // Background color.
    },
  },
};

export default sageThemeConfig;
